module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00006-f5439c8b6de2ea92bf482b27f340d696.jpg";